import * as constants from './constants';

const initialState = {
  // Current playback state
  currentTrack: null, // Track object
  isPlaying: false,
  isLoading: false,
  error: null,

  // Playback tracking
  playbackEventId: null,
  currentTime: 0, // Current playback position in seconds
  duration: 0, // Track duration in seconds
  lastHeartbeatTime: 0, // Timestamp of last heartbeat

  // Tour context
  currentTour: null,
  tourTracks: [], // All tracks in current tour
  currentTrackIndex: -1, // Index in tourTracks array

  // Audio URL (presigned S3 URL)
  audioUrl: null,
};

export default function audioReducer(state = initialState, action) {
  switch (action.type) {
    // Play track
    case constants.PLAY_TRACK_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case constants.PLAY_TRACK_SUCCESS:
      return {
        ...state,
        isLoading: false,
        currentTrack: action.payload.track,
        playbackEventId: action.payload.playbackEventId,
        isPlaying: true,
        currentTime: 0,
        error: null,
      };

    case constants.PLAY_TRACK_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        isPlaying: false,
      };

    // Pause track
    case constants.PAUSE_TRACK:
      return {
        ...state,
        isPlaying: false,
      };

    // Resume track
    case constants.RESUME_TRACK:
      return {
        ...state,
        isPlaying: true,
      };

    // Stop track
    case constants.STOP_TRACK:
      return {
        ...state,
        isPlaying: false,
        currentTrack: null,
        playbackEventId: null,
        currentTime: 0,
        audioUrl: null,
      };

    // Update playback progress
    case constants.UPDATE_PLAYBACK_PROGRESS:
      return {
        ...state,
        currentTime: action.payload.currentTime,
        duration: action.payload.duration,
      };

    // Seek to position
    case constants.SEEK_TO_POSITION:
      return {
        ...state,
        currentTime: action.payload.position,
      };

    // Heartbeat success
    case constants.SEND_PLAYBACK_HEARTBEAT_SUCCESS:
      return {
        ...state,
        lastHeartbeatTime: Date.now(),
      };

    // Load tour tracks
    case constants.LOAD_TOUR_TRACKS:
      const tracks = action.payload.tracks;
      const currentIndex = state.currentTrack
        ? tracks.findIndex(t => t.trackId === state.currentTrack.trackId)
        : -1;

      return {
        ...state,
        tourTracks: tracks,
        currentTrackIndex: currentIndex,
      };

    // Set current tour
    case constants.SET_CURRENT_TOUR:
      return {
        ...state,
        currentTour: action.payload.tour,
      };

    default:
      return state;
  }
}
